export const ALE_MOP_ENVELOPE_VERSION = 1;
export const ALE_MOP_ENCRYPTION = 'ALE';

export type AleMopInnerPayload = {
  EDATA: string;
  ETOKEN: string;
};

/** Builds the VERSION 1 COP envelope for ALE-encrypted MOP payloads. */
export const buildAleMopEnvelope = (ciphertext: string, token: string): string => {
  const innerPayload: AleMopInnerPayload = {
    EDATA: ciphertext,
    ETOKEN: token,
  };

  return JSON.stringify({
    VERSION: ALE_MOP_ENVELOPE_VERSION,
    ENCRYPTION: ALE_MOP_ENCRYPTION,
    PAYLOAD: btoa(JSON.stringify(innerPayload)),
  });
};
